/**
 * @generated SignedSource<<0ffa3a2e8d62a7303c124516b81930a3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PaletteInput = {
  addedColors?: ReadonlyArray<PaletteColorInput> | null;
  colors: ReadonlyArray<PaletteColorInput>;
  deletedColors?: ReadonlyArray<string> | null;
  editedColors?: ReadonlyArray<PaletteColorInput> | null;
  id?: string | null;
  isZakekeDefault: boolean;
  name: string;
  paletteTypeID: number;
  useConversionTable: boolean;
};
export type PaletteColorInput = {
  cmykHexCode?: string | null;
  id?: string | null;
  name?: string | null;
  rgbHexCode: string;
  spotColorName?: string | null;
};
export type createOrEditPaletteDialogUpdateMutation$variables = {
  input: PaletteInput;
};
export type createOrEditPaletteDialogUpdateMutation$data = {
  readonly updatePalette: {
    readonly palette: {
      readonly colors: ReadonlyArray<{
        readonly cmykHexCode: string | null;
        readonly id: string;
        readonly name: string;
        readonly rgbHexCode: string;
        readonly spotColorName: string | null;
      }>;
      readonly id: string;
      readonly isZakekeDefault: boolean;
      readonly name: string;
      readonly paletteTypeID: number;
      readonly useConversionTable: boolean;
    } | null;
  };
};
export type createOrEditPaletteDialogUpdateMutation = {
  response: createOrEditPaletteDialogUpdateMutation$data;
  variables: createOrEditPaletteDialogUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PaletteOutput",
    "kind": "LinkedField",
    "name": "updatePalette",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Palette",
        "kind": "LinkedField",
        "name": "palette",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isZakekeDefault",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paletteTypeID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaletteColor",
            "kind": "LinkedField",
            "name": "colors",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rgbHexCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cmykHexCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "spotColorName",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "useConversionTable",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOrEditPaletteDialogUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOrEditPaletteDialogUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "5e4b69c997a35e2372809e000721d1a8",
    "id": null,
    "metadata": {},
    "name": "createOrEditPaletteDialogUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation createOrEditPaletteDialogUpdateMutation(\n  $input: PaletteInput!\n) {\n  updatePalette(input: $input) {\n    palette {\n      id\n      name\n      isZakekeDefault\n      paletteTypeID\n      colors {\n        name\n        rgbHexCode\n        cmykHexCode\n        spotColorName\n        id\n      }\n      useConversionTable\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7f2fb233e81d1e6e938e4ddd77ea3b38";

export default node;
